import styled from "styled-components";
import {theme} from "assets/themes/bbl";

export const ErrorLabel = styled.label`
	color: ${theme.colors.primary};
	margin: 8px 0 0 0 !important;
	min-height: 14px;
`;
